import {
  CORE_SUGGEST_SEAT_REQUEST,
  CORE_SUGGEST_SEAT_SUCCESS,
  CORE_SUGGEST_SEAT_FAILURE,

  CORE_GET_EVENT_SEATGROUP_REQUEST,
  CORE_GET_EVENT_SEATGROUP_SUCCESS,
  CORE_GET_EVENT_SEATGROUP_FAILURE,

  CORE_GET_MYEVENT_SEATBYDATE_REQUEST,
  CORE_GET_MYEVENT_SEATBYDATE_SUCCESS,
  CORE_GET_MYEVENT_SEATBYDATE_FAILURE,
} from '../types'
const requestState = 'request'
  , initialState = []
  , initialStateObj = {}
export default {
  seatsuggest: (state = requestState, action) => {
    switch (action.type) {
      case CORE_SUGGEST_SEAT_REQUEST:
        return requestState
      case CORE_SUGGEST_SEAT_SUCCESS:
        let result = []
        if (result && Array.isArray(action.payload)) {
          result = action.payload
        }
        return result
      case CORE_SUGGEST_SEAT_FAILURE:
        return initialState
      default:
        return state
    }
  },
  myeventseat: (state = requestState, action) => {
    switch (action.type) {
      case CORE_GET_MYEVENT_SEATBYDATE_REQUEST:
        return requestState
      case CORE_GET_MYEVENT_SEATBYDATE_SUCCESS:
        let result = []
        if (result && Array.isArray(action.payload)) {
          result = action.payload
        }
        return result
      case CORE_GET_MYEVENT_SEATBYDATE_FAILURE:
        return initialState
      default:
        return state
    }
  },
  eventSeatGroup: (state = requestState, action) => {
    switch (action.type) {
      case CORE_GET_EVENT_SEATGROUP_REQUEST:
        return requestState
      case CORE_GET_EVENT_SEATGROUP_SUCCESS:
        let result = {}
        if (result && Object.keys(action.payload).length > 0) {
          result = action.payload
        }
        return result
      case CORE_GET_EVENT_SEATGROUP_FAILURE:
        return initialStateObj
      default:
        return state
    }
  },
}



// WEBPACK FOOTER //
// ./src/reducers/reducerSeat.js